module.exports = __webpack_public_path__ + "img/festa1.460ff953.png";